import { z } from 'zod';

/**
 * Configuração de runtime (ADR-0014): vem de `/config.js`, gerado pelo contêiner a partir das
 * variáveis de ambiente. Só valores públicos; nenhum segredo vai para o navegador (constituição III).
 */
const esquema = z
  .object({
    ambiente: z.enum(['desenvolvimento', 'staging', 'producao']),
    pagarmeChavePublica: z.string().trim(),
    suporteEmail: z.email(),
    /** Lojas do app do aluno, mostradas depois do convite (spec 002, CA-13). Opcionais. */
    appAndroidUrl: z.url().optional(),
    appIosUrl: z.url().optional(),
  })
  .refine((c) => c.ambiente === 'desenvolvimento' || c.pagarmeChavePublica.length > 0, {
    path: ['pagarmeChavePublica'],
    message: 'obrigatória fora do desenvolvimento',
  });

export type Config = z.infer<typeof esquema>;

export type LeituraDaConfig =
  { ok: true; config: Config } | { ok: false; problemas: readonly string[] };

declare global {
  interface Window {
    __CONFIG__?: unknown;
  }
}

/** Lê e valida a configuração. Nunca lança: o `main.tsx` mostra a tela de erro de configuração. */
export function lerConfig(bruta: unknown = window.__CONFIG__): LeituraDaConfig {
  const resultado = esquema.safeParse(bruta);
  if (resultado.success) return { ok: true, config: resultado.data };
  const problemas = resultado.error.issues.map((issue) => {
    const campo = issue.path.join('.') || 'config';
    return issue.code === 'invalid_type' ? `${campo}: obrigatório` : `${campo}: ${issue.message}`;
  });
  return { ok: false, problemas };
}
